<template lang="pug">
Sidebar.breadcrumb-pad(
		:collapsed="!show"
		v-bind="$props"
		@sidebar:collapse="toggleSidebar(false)"
		@sidebar:uncollapse="toggleSidebar(true)"
		:scroll-top="sidebarScrollTop"
		)
	header booya 
		.card booya 2
	slot
</template>

<script>
import { Component, Mixins } from "vue-property-decorator";
import Sidebar from "@/components/Sidebar";
import ViewportAware from "@/mixins/ViewportAware";
import SearchInput from "@/components/SearchInput";
import ToggleSwitch from "@/components/ToggleSwitch";
import DeviceTypeFilter from "@/views/DeviceManager/DeviceTypeFilter";
import Tooltip from "@/components/Tooltip";

@Component({
	components: {
		Sidebar,
		SearchInput,
		ToggleSwitch,
		DeviceTypeFilter,
		Tooltip
	}
})
class FloodDssSidebar extends Mixins(ViewportAware) {}

export default FloodDssSidebar;
</script>

<style lang="stylus" scoped>
.sidebar
	overflow hidden

.toggle
	display inline-block
	vertical-align middle
	margin-left 10px

.card
	text-align left
	background-color $very-light-bg-color
	padding 0.5em
	margin 0.2em 0.2em 0.5em 0.2em
	box-shadow 0 0.1em 0.1em rgba(0, 0, 0, 0.3)

	.card__section, .card__heading
		border-bottom 1px solid #aaa
		padding 0.5em

	.card__heading
		display flex
		justify-content center
		align-items center

.flex
	display flex
	margin 0.5em

	&.align-center
		align-items center

	&.space-between
		justify-content space-between
</style>
